namespace GeniuzPOS.Customer {
    export interface CsCustGroupForm {
        CustGroupCode: Serenity.StringEditor;
        CustGroupName: Serenity.StringEditor;
    }

    export class CsCustGroupForm extends Serenity.PrefixedContext {
        static formKey = 'Customer.CsCustGroup';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CsCustGroupForm.init)  {
                CsCustGroupForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(CsCustGroupForm, [
                    'CustGroupCode', w0,
                    'CustGroupName', w0
                ]);
            }
        }
    }
}
